"use strict";

/**
 * Provides an image.
 */
const image = () => reactotron => {
  return {
    features: {
      // expanded just to show the specs
      image: payload => {
        const {
          uri,
          preview,
          filename,
          width,
          height,
          caption
        } = payload;
        return reactotron.send("image", {
          uri,
          preview,
          filename,
          width,
          height,
          caption
        });
      }
    }
  };
};
export default image;
//# sourceMappingURL=image.js.map